export const formatNames = (bride_name, groom_name) => {
  const brideName = bride_name?.split(' ')[0];
  const groomName = groom_name?.split(' ')[0];

  return brideName && groomName ? `${brideName} & ${groomName}` : brideName ? brideName : groomName ? groomName : '';
}